module.exports = __webpack_public_path__ + "static/media/EST.0a6b9e33.svg";